// @flow
import { format, parseISO, formatDistance } from 'date-fns';
import moment from 'moment';
import setHours from 'date-fns/setHours';
import setMinutes from 'date-fns/setMinutes';
import { CURRENT_COUNTRY_CODE } from 'config/env';

const getShortDisplayDateFromISOString = (dateString: string): string => {
  return moment(dateString).utc().format('MMM DD');
};

const getDisplayDateFromISOString = (dateString: string): string => {
    let date = new Date();
    let current_date = moment(date)
      .utc()
      .format('DD MMM YYYY');
    let format_date = moment(dateString)
      .utc()
      .format('DD MMM YYYY');
    if (current_date === format_date) {
      format_date = 'Today';
    }
    return format_date;  
};

const getDisplayMonthDateFromISOString = (dateString: string): string => {
  if (dateString !== undefined && dateString !== null) {
    const date = parseISO(dateString);
    return format(date, 'MMMM dd');
  }
  return;
};

const getDisplayTimeFromISOString = (dateString: string): string => {
  const date = parseISO(dateString);

  return format(date, 'p');
};

const getDistanceDateFromISOString = (dateString: string): string => {
  const date = parseISO(dateString);

  return formatDistance(date, new Date());
};

const getClosedOpenStatus = (opensAt: string, closesAt: string): boolean => {
  const formatTime = 'hh:mm:ss';
  const currentTime = moment();
  const beforeTime = moment(opensAt, formatTime);
  const afterTime = moment(closesAt, formatTime);
  const isOpenTimeGreater = beforeTime.isAfter(afterTime);
  if (isOpenTimeGreater) {
    if (currentTime.isAfter(beforeTime) || currentTime.isBefore(afterTime)) {
      return true;
    } else {
      return false;
    }
  } else {
    return currentTime.isBetween(beforeTime, afterTime);
  }
};

const getIsTodayRestaurantClose = (closing_day: string): boolean => {
  const today = moment().format('YYYY-MM-DD');
  const closingDate = moment(closing_day).format('YYYY-MM-DD');
  return moment(closingDate).isSame(today);
};

const getPastEventsDate = date => {
  return moment(date).format('MMMM YYYY');
};

const getFullDateWithDay = date => {
  return moment(date).utc().format('dddd, MMMM D, YYYY');
};

const getFullDate = date => {
  return moment(date).utc().format('MMMM D, YYYY');
};

const getIsSameDay = (first_date, second_date): boolean => {
  let initial_date = moment(first_date).format('YYYY MM DD');
  let final_date = moment(second_date).format('YYYY MM DD');
  return initial_date === final_date;
};

const getEventDetailBannerDate = (date, time) => {
  const current_date = moment().utc().format('dddd, MMM DD');
  let formattedDate = moment(date).utc().format('dddd, MMM DD');
  if (formattedDate === current_date) {
    formattedDate = 'Today';
  }

  return time ? `${formattedDate}${', '}${time}` : formattedDate;
};

const getFullDateString = date => {
  return moment.utc(date).format('YYYY-MM-DD');
};

const getFormattedTime = timeObject => {
  const formatTime = 'hh:mm:ss';
  timeObject = moment(timeObject, formatTime);
  return setHours(setMinutes(0, timeObject.minutes()), timeObject.hours());
};

const getSortedDates = dates => {
  return (
    dates &&
    dates.sort(function(a, b) {
      return (
        new Date(getFormattedDateTimeObject(b)) -
        new Date(getFormattedDateTimeObject(a))
      );
    })
  );
};

const getFormattedDateTimeObject = dateTimeObject => {
  let time = moment(dateTimeObject.start_time, ['h:mm A']).format('HH:mm');
  let date = getFullDateString(dateTimeObject.concert_date);
  return date + ' ' + time;
};

const getFilteredDates = dates => {
  let today_date = moment().format('YYYY-MM-DDTHH:mm:ss ');
  return dates.filter(item => {
    let date = DateUtil.getFullDateString(item.concert_date);
    let time = moment(item.start_time, ['HH.mm']).format('hh:mm a');
    let updated_time = time.split(' ');
    let event_date = date + 'T' + updated_time[0] + ':00';
    return event_date;
  });
};

const roundCurrentTime = dateObject => {
  let current_minutes = dateObject.getMinutes();
  if (current_minutes > 30) {
    //if minutes of date-object are more than 30, than it roundsOff the time to next upcoming hour
    dateObject.setHours(dateObject.getHours() + 1);
    dateObject.setMinutes(0, 0, 0);
  }
  if (current_minutes < 30) {
    //if minutes of date-object are less than 30, than it roundsOff the time to next half-an hour
    let minutes_left = 30 - current_minutes;
    dateObject.setMinutes(dateObject.getMinutes() + minutes_left, 0, 0);
  }
  return dateObject;
};

const DatesCollectionBasedOnTimeRange = (initial_time, final_time) => {
  let until = Date.parse('01/01/2001 ' + final_time);
  let from = Date.parse('01/01/2001 ' + initial_time);
  let max = (Math.abs(until - from) / (60 * 60 * 1000)) * 2;
  let time = new Date(from);
  let collection = [];
  for (let i = 0; i <= max; i++) {
    let hour = time.getHours();
    let minute = time.getMinutes();
    let formatted_time = getFormattedTime(hour + ':' + minute);
    collection.push(formatted_time);
    time.setMinutes(time.getMinutes() + 30);
  }
  return collection;
};

export const DateUtil = {
  getDisplayDateFromISOString,
  getDisplayMonthDateFromISOString,
  getShortDisplayDateFromISOString,
  getDisplayTimeFromISOString,
  getDistanceDateFromISOString,
  getClosedOpenStatus,
  getIsTodayRestaurantClose,
  getPastEventsDate,
  getFullDateWithDay,
  getFullDate,
  getIsSameDay,
  getEventDetailBannerDate,
  getFullDateString,
  getFormattedTime,
  getSortedDates,
  getFilteredDates,
  roundCurrentTime,
  DatesCollectionBasedOnTimeRange,
};
